module.exports = __webpack_public_path__ + "static/img/sport_bg1.cac28213.jpg";